export const REFRESH_OUTCOME_VALUES = ['REFRESHED', 'INVALID', 'UNAVAILABLE'] as const;

export const RefreshOutcome = {
  REFRESHED: 'REFRESHED',
  INVALID: 'INVALID',
  UNAVAILABLE: 'UNAVAILABLE',
} as const;

export type RefreshOutcome = (typeof RefreshOutcome)[keyof typeof RefreshOutcome];

export type RefreshCoordinatorOptions = {
  getTokenGeneration: () => number;
  performRefresh: () => Promise<RefreshOutcome>;
};

export type RefreshCoordinator = (generation: number) => Promise<RefreshOutcome>;

/**
 * Single-flight token refresh. All concurrent callers passing the token generation they
 * observed share one in-flight `performRefresh()` call instead of racing separate refreshes.
 * A caller whose generation is already stale (another refresh completed since it read the
 * token) short-circuits to REFRESHED without touching the network.
 */
export const createRefreshCoordinator = ({
  getTokenGeneration,
  performRefresh,
}: RefreshCoordinatorOptions): RefreshCoordinator => {
  let pending: Promise<RefreshOutcome> | null = null;

  return (generation) => {
    if (getTokenGeneration() !== generation) {
      return Promise.resolve(RefreshOutcome.REFRESHED);
    }
    if (!pending) {
      pending = performRefresh().finally(() => {
        pending = null;
      });
    }
    return pending;
  };
};
